<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRiChengList"
      data-title="住宿"
    ></div>
    <div class="content c-table-box mt-2 rounded-lg">
      <div
        class="bg-white p-4 rounded-lg mb-3 flex flex-col text-xs gap-y-3"
        v-for="item in state.list_data"
        :key="item"
      >
        <ul class="flex gap-x-5">
          <strong>{{ item.name }}</strong>
          <text class="text-gray-400">{{ item.dz }}</text>
        </ul>
        <ul class="grid gap-x-5" style="grid-template-columns: 50px auto auto">
          <li class="text-gray-400 text-center">入住人数</li>
          <div class="flex gap-x-3">
            <strong>{{ item.fh }}</strong>
            <text class="text-gray-400">{{ item.lx }}</text>
          </div>
          <div class="flex gap-x-2 text-gray-400">
            <strong class="text-gray-600">{{ item.ksrq }}</strong>
            <text>入住</text>
            <strong class="text-gray-600">{{ item.jzrq }}</strong>
            <text>退房</text>
            共
            <strong class="text-gray-600">{{ item.jy }}</strong>
            晚
          </div>
        </ul>
        <ul class="grid gap-x-5" style="grid-template-columns: 50px auto">
          <li class="text-center font-bold text-orange-500">
            {{ item.rzrs.length }}
          </li>
          <div class="flex flex-wrap gap-x-10 gap-y-2 text-gray-400">
            <div
              v-for="(rs, index) in item.rzrs"
              :key="rs"
              class="flex gap-x-2"
            >
              <text>入住人{{ index + 1 }}:</text>
              <text class="text-gray-600">{{ rs.xm }}</text>
              <c_sex :value="rs.xb" />
              <text>{{ rs.sjh }}</text>
            </div>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  setup() {
    const state = reactive({});
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      state.list_data = [
        {
          name: "双龙商务大酒店",
          dz: "合肥市肥东县长江东路025号",
          rs: 2,
          fh: "14楼-1401",
          lx: "标准间",
          ksrq: "2026-04-14",
          jzrq: "2026-04-16",
          jy: 2,
          rzrs: [
            {
              xm: "张千惠",
              xb: "女",
              sjh: "18999999999",
            },
            {
              xm: "李文飞",
              xb: "男",
              sjh: "18000000002",
            },
          ],
        },
      ];
    };
    return { state };
  },
};
</script>

<style lang="less" scoped></style>
